import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import Swal from "sweetalert2";

import { UserService } from "../../../../../services";
import { User, Errors } from "../../../../../models";

@Component({
  selector: "del-account-auth-form",
  templateUrl: "./del-account-auth-form.component.html",
  styleUrls: [
    "./del-account-auth-form.component.scss",
    "../../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class DelAccountAuthForm implements OnInit {
  @Input() currentUser: User;
  public errors: Errors = new Errors();
  public isSubmitting: boolean = false;
  public authForm: FormGroup;

  constructor(
    private router: Router,
    private userService: UserService,
    private fb: FormBuilder
  ) {
    // use FormBuilder to create a form group
    this.authForm = this.fb.group({
      email: ["", Validators.required],
      password: ["", Validators.required],
    });
  }

  ngOnInit() {}

  public logout() {
    this.userService.logOut().subscribe(() => {
      this.userService.purgeAuth();
      this.router.navigateByUrl("/");
    });
  }

  public deleteAccount() {
    this.isSubmitting = true;
    this.errors = new Errors();

    let credentials = this.authForm.value;
    this.userService.destroy(credentials).subscribe(
      (data) => {
        this.fireSuccessAlert();
        this.logout();
      },
      (err) => {
        this.errors = err;
        this.isSubmitting = false;
        this.fireErrorAlert();
      }
    );
  }

  public attemptLocalAuth() {
    Swal.fire({
      title: "Delete?",
      text: "Deleting your account will not delete your content. Delete content first to remove all your content",
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "Haai, cancel!",
      confirmButtonText: "Delete my membership!",
    }).then((result) => {
      if (result.value) {
        this.authorizeDeletion();
      }
    });
  }

  public authorizeDeletion() {
    Swal.fire({
      title: "Delete?",
      text: "Vele vele, this is goodbye " + this.currentUser.username + "?",
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "Haai, cancel!",
      confirmButtonText: "Delete my account!",
    }).then((result) => {
      if (result.value) {
        this.deleteAccount();
      }
    });
  }

  public fireSuccessAlert() {
    Swal.fire({
      title: "Deleted",
      text: "Account deleted",
      type: "success",
    });
  }

  public fireErrorAlert() {
    Swal.fire("Eish!", "There were errors with your deletion", "warning");

    function errorAlert() {
      Swal.close();
    }
    setTimeout(errorAlert, 3000);
  }
}
